import React from 'react';

import { Avatar, AvatarBadge } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useTheme } from 'hooks/useTheme';

import { ContainerAvatar } from './styles';
import { getTheme } from './themes';
import { IAvatarInvitationProps } from './types';

const AvatarInvitation: React.FC<IAvatarInvitationProps> = ({
  type,
  name,
  src,
  size = 'md',
  hideBadge = false,
}) => {
  const { theme: globalTheme } = useTheme();
  const { icon } = getTheme(type, globalTheme);

  return (
    <ContainerAvatar {...getTheme(type, globalTheme)} size={size} hideBadge={hideBadge}>
      <Avatar size={size} name={name} src={src}>
        <AvatarBadge boxSize="1.25em">
          <FontAwesomeIcon icon={icon} />
        </AvatarBadge>
      </Avatar>
    </ContainerAvatar>
  );
};

export default AvatarInvitation;
